(function () {
  'use strict';
  var element = document.getElementById('CartGiftRuntimeConfig');
  if (!element || !window.CartGiftUtils || window.CartGiftRuntime) return;
  var config = JSON.parse(element.textContent);
  var utils = window.CartGiftUtils;
  var nativeFetch = window.fetch.bind(window);
  var clients = [];
  var syncing = false;
  var pending = false;
  var timer;
  var scheduleTimer;
  var externalRequests = 0;
  var lastFingerprint = '';
  var needsRefresh = false;
  var lastCart = config.initialCart;
  var dismissals = {};
  var ajaxRemovals = new WeakMap();

  function rememberCart(cart) {
    if (cart && cart.token && Array.isArray(cart.items)) lastCart = cart;
    return cart;
  }

  function dismissedGifts(token) {
    var saved = dismissals[token] || [];
    try {
      var stored = JSON.parse(window.localStorage.getItem('cart-gift-dismissals:' + token));
      if (Array.isArray(stored)) stored.forEach(function (id) {
        if (typeof id === 'string' && saved.indexOf(id) === -1) saved.push(id);
      });
    } catch (_) {} // Storage restrictions must never prevent shopping.
    dismissals[token] = saved;
    return saved;
  }

  function recordRemovals(candidates, cart) {
    if (!cart || !cart.token || !Array.isArray(cart.items) || !candidates.length) return;
    var saved = dismissedGifts(cart.token);
    candidates.forEach(function (item) {
      var id = utils.giftIdentity(item);
      // Only a successful, explicit removal counts; key changes and failed
      // requests must not opt the customer out of a promotion.
      if (saved.indexOf(id) === -1 && !cart.items.some(function (line) { return utils.giftIdentity(line) === id; })) {
        saved.push(id);
      }
    });
    try { window.localStorage.setItem('cart-gift-dismissals:' + cart.token, JSON.stringify(saved)); } catch (_) {}
  }
  // theme-scripts renders in <head>. Create the live region in <body> once this
  // deferred script runs, rather than emitting invalid body markup in the head.
  var status = document.createElement('span');
  status.id = 'CartGiftStatus';
  status.className = 'yv-visually-hidden';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.setAttribute('aria-atomic', 'true');
  document.body.appendChild(status);

  function request(url, data) {
    var options = { headers: { Accept: 'application/json' }, cache: 'no-store' };
    if (data) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(data);
    }
    // Bypass our own observer. Only customer/app mutations should enqueue another pass.
    return nativeFetch(url, options).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) {
          var error = new Error(payload.description || payload.message || response.statusText);
          error.status = response.status;
          throw error;
        }
        return rememberCart(payload);
      });
    });
  }

  function mutate(url, data) {
    if (externalRequests || pending) return Promise.reject(new Error('Cart changed during gift synchronization'));
    needsRefresh = true;
    return request(url, data);
  }

  var api = {
    isGiftDismissed: function (item) {
      return Boolean(lastCart && lastCart.token && dismissedGifts(lastCart.token).indexOf(utils.giftIdentity(item)) !== -1);
    },
    getCart: function () { return request(config.cartUrl); },
    add: function (items) { return mutate(config.addUrl, { items: items }); },
    update: function (updates) { return mutate(config.updateUrl, { updates: updates }); },
    change: function (key, quantity) { return mutate(config.changeUrl, { id: key, quantity: quantity }); }
  };

  function scheduleSync() {
    pending = true;
    window.clearTimeout(timer);
    if (!syncing && !externalRequests) timer = window.setTimeout(sync, 150);
  }

  function refresh(cart) {
    if (typeof window.updateCartCount === 'function') window.updateCartCount(cart.item_count);
    var rebuy = window.Rebuy && window.Rebuy.Cart;
    if (rebuy && typeof rebuy.fetchCart === 'function') rebuy.fetchCart();

    if (window.location.pathname.replace(/\/$/, '') === config.cartPath.replace(/\/$/, '') &&
        typeof window.cartPageUpdate === 'function') {
      window.cartPageUpdate(cart, { preserveFocus: true });
    } else if (!rebuy && typeof window.buildCart === 'function' && document.querySelector('[data-drawer-body]')) {
      window.buildCart(cart, false, null, { preserveFocus: true });
    }
    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true, detail: { cart: cart, source: 'cart-gift-runtime' }
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true, detail: { cart: cart, source: 'cart-gift-runtime' }
    }));
    status.textContent = '';
    window.setTimeout(function () { status.textContent = config.updatedMessage; }, 50);
  }

  async function sync() {
    if (syncing || externalRequests || !clients.length) return;
    syncing = true;
    pending = false;
    var cart;
    var before;
    try {
      cart = await api.getCart();
      before = utils.fingerprint(cart);
      for (var i = 0; i < clients.length; i++) {
        // An intervening customer change invalidates this snapshot.
        if (externalRequests || pending) break;
        cart = await clients[i].reconcile(cart, api);
      }
      lastFingerprint = utils.fingerprint(cart);
      if (!externalRequests && !pending && (needsRefresh || before !== lastFingerprint)) {
        needsRefresh = false;
        refresh(cart);
      }
    } catch (error) {
      console.warn('Cart gifts could not be synchronized.', error);
      // A failed write can still have changed the cart (for example, inventory limits).
      // Refresh once, without retrying indefinitely or blocking normal shopping.
      try {
        cart = await api.getCart();
        lastFingerprint = utils.fingerprint(cart);
        if (!externalRequests && !pending && needsRefresh) {
          needsRefresh = false;
          refresh(cart);
        }
      } catch (_) {}
    } finally {
      syncing = false;
      if (pending) scheduleSync();
    }
  }

  function mutationType(input) {
    try {
      var url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      var match = url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/);
      return match && match[1];
    } catch (_) { return null; }
  }

  function changed(type, payload) {
    if (type === 'add') clients.forEach(function (client) {
      if (client.onAdd) client.onAdd(payload);
    });
    scheduleSync();
  }

  window.fetch = function () {
    var type = mutationType(arguments[0]);
    if (!type) return nativeFetch.apply(null, arguments);
    var input = arguments[0];
    var options = arguments[1];
    var snapshot = lastCart;
    var body;
    try {
      if (options && options.body !== undefined) body = options.body;
      else if (typeof Request !== 'undefined' && input instanceof Request) {
        var copy = input.clone();
        body = (copy.headers.get('Content-Type') || '').indexOf('multipart/form-data') !== -1 ? copy.formData() : copy.text();
      } else body = new URL(input, window.location.origin).searchParams;
    } catch (_) {}
    var removals = Promise.resolve(body).then(function (data) {
      return utils.removalCandidates(snapshot, type, data);
    }).catch(function () { return []; });
    externalRequests++;
    var promise;
    try { promise = nativeFetch.apply(null, arguments); }
    catch (error) { externalRequests--; throw error; }
    promise.then(async function (response) {
      var payload;
      try { payload = await response.clone().json(); } catch (_) {}
      if (response.ok) recordRemovals(await removals, payload);
      rememberCart(payload);
      // Even a 422 can partially add inventory. Reconcile the actual cart afterwards.
      if (response.ok || response.status === 422) changed(type, payload);
    }).catch(function () {}).finally(function () {
      externalRequests--;
      if (pending) scheduleSync();
    });
    return promise;
  };

  if (window.jQuery) {
    window.jQuery(document).ajaxSend(function (_event, _xhr, settings) {
      var type = mutationType(settings.url);
      if (type) {
        externalRequests++;
        ajaxRemovals.set(_xhr, utils.removalCandidates(lastCart, type, settings.data));
      }
    });
    window.jQuery(document).ajaxComplete(function (_event, xhr, settings) {
      var type = mutationType(settings.url);
      if (!type) return;
      externalRequests = Math.max(0, externalRequests - 1);
      var payload = xhr.responseJSON;
      if (!payload) { try { payload = JSON.parse(xhr.responseText); } catch (_) {} }
      if (xhr.status >= 200 && xhr.status < 300) recordRemovals(ajaxRemovals.get(xhr) || [], payload);
      ajaxRemovals.delete(xhr);
      rememberCart(payload);
      if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 422) changed(type, payload);
      else if (pending) scheduleSync();
    });
  }

  function cartEvent(event) {
    var detail = event.detail || {};
    if (detail.source === 'cart-gift-runtime') return;
    var cart = detail.cart && (detail.cart.cart || detail.cart);
    if (cart && Array.isArray(cart.items) && utils.fingerprint(cart) === lastFingerprint) return;
    scheduleSync();
  }
  ['cart:refresh', 'cart:updated', 'rebuy:cart.change', 'rebuy:cart.ready'].forEach(function (name) {
    document.addEventListener(name, cartEvent);
  });

  function checkSchedules() {
    window.clearTimeout(scheduleTimer);
    var future = false;
    clients.forEach(function (client) {
      var state = client.scheduleState();
      if (client.lastSchedule !== undefined && client.lastSchedule !== state.key) scheduleSync();
      client.lastSchedule = state.key;
      future = future || state.future;
    });
    // Only the local clock is checked; no cart request unless eligibility changes.
    if (future && !document.hidden) scheduleTimer = window.setTimeout(checkSchedules, 60020 - Date.now() % 60000);
  }
  function resume() { checkSchedules(); scheduleSync(); }
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) resume();
    else window.clearTimeout(scheduleTimer);
  });
  window.addEventListener('pageshow', function (event) { if (event.persisted) resume(); });

  window.CartGiftRuntime = {
    register: function (client) {
      clients.push(client);
      checkSchedules();
      scheduleSync();
    }
  };
})();
